import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {Organisation, PaymentGateway} from '@/types/Organisation';
import { Player } from '@/types/Player';

interface OrganisationState {
    organisation: Organisation | null;
    loading: boolean;
    error: string | null;
}

const initialState: OrganisationState = {
    organisation: null,
    loading: false,
    error: null,
};

const organisationSlice = createSlice({
    name: 'organisation',
    initialState,
    reducers: {
        fetchOrganisationSuccess(state, action: PayloadAction<Organisation>) {
            const org = action.payload;

            // Convert players object => array if needed
            if (org.players && !Array.isArray(org.players)) {
                org.players = Object.values(org.players) as Player[];
            }

            state.organisation = org;
            state.loading = false;
        },
        setOrganisation(state, action: PayloadAction<Organisation>) {
            state.organisation = action.payload;
        },
        setPaymentGateways(state, action: PayloadAction<PaymentGateway[]>) {
            if (state.organisation) {
                state.organisation.paymentGateways = action.payload;
            }
        },
        updateLogo(state, action: PayloadAction<string>) {
            if (state.organisation) {
                state.organisation.logoUrl = action.payload;
            }
        },
        updateSetup(state, action: PayloadAction<{ equipment?: boolean; logo?: boolean; organisationDetails?: boolean; package?: boolean; services?: boolean; players?: boolean }>) {
            if (state.organisation) {
                state.organisation.setup = {
                    ...state.organisation.setup,
                    ...action.payload
                };
            }
        },
    },
});

export const {
    fetchOrganisationSuccess,
    setOrganisation,
    setPaymentGateways,
    updateLogo,
    updateSetup,
} = organisationSlice.actions;

export default organisationSlice.reducer;
